import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getContact, updateContact } from '../Store/ActionCreators/ContactActionCreator'
export default function ContactView() {
  const [data, setData] = useState('')
  const dispatch = useDispatch()
  const contactView = useSelector((state)=>state.ContactStateData)
  const {_id} = useParams()
 const handleStatusChange = () => {
  const updatedData = {
    ...data,
    status: data.status === "Active" ? "Inactive" : "Active"
  };

  setData(updatedData);            // UI instant update
  dispatch(updateContact(updatedData)); // backend update
};

  useEffect(()=>{
    dispatch(getContact())
  },[dispatch])

useEffect(() => {
    if (contactView?.length > 0 && _id) {
        const student = contactView.find(
        (item) => item._id === (_id)
        );
        if (student) {
        setData(student);
        }
    }
    }, [contactView, _id]);

   


  return (
    <>
      <Box sx={{display:"flex"}}> 
      <Sidebar />
      <Box  className="boxStyle w-100">
        <div className="mt-5" >
          <h2 className='text-light bg-success text-center rounded p-1' style={{margin:"100px 20px 0px 20px"}}><i>Contact View Page</i></h2>
          <div className="contactView" style={{margin:"40px", border:"1px solid #575656ff",padding:"20px",borderRadius:"10px",boxShadow:"1px 1px 15px 2px #575656ff"}}>
            <div className="d-flex w-100">
              <div className="mb-3 w-50 m-2 p-3 rounded" style={{border:"1px solid #000"}}>Name : {data.name}</div>
              <div className="mb-3 w-50 m-2 p-3 rounded" style={{border:"1px solid #000"}}>Mobile  : {data.mobile}</div>
            </div>
            <div className="mb-3 w-100 m-2 p-3 rounded" style={{border:"1px solid #000"}}>Sunbject : {data.subject}</div>
            <div className="mb-3 w-100 m-2 p-3 rounded" style={{border:"1px solid #000"}}>Message : <br/> {data.message} </div>
            <div className="mb-3 w-100 m-2 p-3 rounded" style={{border:"1px solid #000"}}>
              {data && (
                <>
                  <h4>Status :
                    <span className={data.status === "Active" ? "text-success" : "text-danger"}>
                      {" "}{data.status}
                    </span>
                  </h4>
                </>
              )}
            </div>
            <Button className='w-100'
                variant="contained"
                color={data.status === "Active" ? "error" : "success"}
                onClick={handleStatusChange}
                sx={{ mt: 2 }}
              >
                {data.status === "Active" ? "Deactivate" : "Activate"}
              </Button>
        </div>
        </div>
      </Box>
    </Box>
    </>
  )
}
